import React, { useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReadyToImg from "../../assets/img/home-ready-to.png";
import clsx from "clsx";
import AnimatedContent from "../AnimatedContent";
import { useJoinWaitlistModal } from "../../context/ModalContext";

const ReadyTo = () => {
    const { openJoinWaitlistModal } = useJoinWaitlistModal();
    const navigate = useNavigate();
    return <div className={clsx(
        "flex flex-col items-center py-[80px] text-center relative w-full px-[16px] max-w-[1112px] mx-auto",
        "md:py-[120px]"
    )}>
        <div className={clsx(
            "text-[32px] font-semibold leading-[1.2] tracking-[-1.28px] mb-[16px] relative z-[2]",
            "md:text-[46px] md:tracking-[-1.84px]"
        )}>
            <AnimatedContent>
                Ready to put your TAO to work?
            </AnimatedContent>
        </div>
        <div className={clsx(
            "text-[14px] text-white/70 mb-[40px] relative z-[2]",
            "md:text-[18px] md:text-white"
        )}>
            <AnimatedContent>
                Earn yield. Borrow with leverage. All in one place.
            </AnimatedContent>
        </div>
        <div className="flex md:flex-row flex-col gap-[12px] w-full justify-center items-center relative z-[2]">
            <div className="w-full md:w-fit flex justify-center" onClick={() => openJoinWaitlistModal(() => {
                            navigate('/dashboard');
                        })}>
                <AnimatedContent>
                    <button className="px-[40px] py-[24px] md:w-fit w-full max-w-[263px] rounded-[100px] bg-white text-black text-[16px] font-medium border border-transparent hover:opacity-80 transition-all duration-300">
                        Launch App
                    </button>
                </AnimatedContent>
            </div>
            <Link to="https://taoflow-1.gitbook.io/taoflow-docs" className="w-full md:w-fit flex justify-center">
                <AnimatedContent>
                    <button className="px-[40px] py-[24px] md:w-fit w-full max-w-[263px] rounded-[100px] border-btn text-[16px] font-medium transition-all duration-300">
                        Learn More
                    </button>
                </AnimatedContent>
            </Link>
        </div>
        <img
            src={ReadyToImg}
            alt="ReadyTo"
            className={clsx(
                "absolute h-full object-cover",
                "md:bottom-0 md:right-0 md:translate-y-[40%] md:w-full"
            )}
        />
    </div>;
};

export default ReadyTo;
